
import { supabase } from "@/integrations/supabase/client";
import { AtheismResponse, SavedAtheismContent } from "../types";
import { Json } from "@/integrations/supabase/types";
import { toast } from "@/hooks/use-toast";

export const fetchAtheismDefense = async (question: string) => {
  const { data, error: fnError } = await supabase.functions.invoke('atheism-defense', {
    body: { question: question.trim() },
  });
  
  if (fnError) {
    throw new Error(fnError.message || "Failed to get response from the server");
  }
  
  console.log("API Response:", data);
  
  if (!data.response) {
    throw new Error("The response format was unexpected. Please try again.");
  }
  
  return data.response as AtheismResponse;
};

export const saveAtheismResponse = async (
  userId: string, 
  question: string, 
  response: AtheismResponse
) => {
  console.log("Saving atheism defense response...");
  
  // Create a properly formatted content object for storage
  const contentObj: SavedAtheismContent = {
    question,
    response,
    createdAt: new Date().toISOString()
  };
  
  console.log("Content prepared for storage:", contentObj);
  
  const { error: insertError, data: savedData } = await supabase
    .from('saved_responses')
    .insert({
      tool_type: 'atheism_defense',
      title: `Atheism Defense: ${question.substring(0, 50)}${question.length > 50 ? '...' : ''}`,
      content: contentObj as unknown as Json,
      user_id: userId
    })
    .select();

  if (insertError) {
    console.error("Error inserting saved response:", insertError);
    throw insertError;
  }

  console.log("Response saved successfully:", savedData);

  toast({
    title: "Response Saved",
    description: "Your response has been saved to your dashboard."
  });
  
  return savedData;
};
